import { useEffect, useMemo, useState } from "react";
import ReactGA from "react-ga4";
import { useHistory, useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { SwipeableDrawer } from "@material-ui/core";
import moment from "moment";

import "./jobs.scss";
import Title from "../../uiKit/Title/Title";
import CustomButton from "../../uiKit/Button/CustomButton";
import CustomSelect from "../../uiKit/CustomSelect/CustomSelect";
import CustomInput from "../../uiKit/Input/CustomInput";
import { Close, Magnificer } from "../../uiKit/assets/svg/icons";
import { gray010, gray650 } from "../../uiKit/assets/colors/colors";
import { FilterIcon } from "../../uiKit/assets/svg/filterIcon";
import AnimatedLoading from "../../uiKit/Loading/animatedLoading";
import CustomPagination from "../../uiKit/CustomTable/pagination";
import CustomMobilePagination from "../../uiKit/CustomTable/mobilePagination";

import { getEmploymentTypes, getJobLocations, getJobs } from "../../redux/state/jobSlice";

const useStyles = makeStyles(() => ({
  paper: {
    width: "80%",
    backgroundColor: gray010,
    padding: "24px",
    justifyContent: "space-between",
  },
}));

const Jobs = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const drawerClasses = useStyles();

  const employmentTypeList = useSelector((state) => state.job.employmentTypes, shallowEqual);
  // const locationList = useSelector((state) => state.job.locations, shallowEqual);
  const screenWidth = useSelector((state) => state.common.screenWidth, shallowEqual);
  const isMobile = screenWidth <= 767;

  // const [location, setLocation] = useState(0);
  const [employmentType, setEmploymentType] = useState(0);
  const [searchJob, setSearchJob] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: `/jobs` });
  }, []);

  useEffect(() => {
    dispatch(getJobLocations());
    dispatch(getEmploymentTypes());
  }, [dispatch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const page = query.get("page") || "1";
      const pageSize = query.get("pageSize") || "9";

      dispatch(
        getJobs({
          page,
          pageSize,
          status: 3,
          searchString: searchJob,
          employmentType,
        })
      );
    }, 1000);

    return () => clearTimeout(timeout);
  }, [dispatch, query, searchJob, employmentType]);

  const employmentTypeHandler = (event) => {
    const value = event.target.value;
    setEmploymentType(value);
  };

  // const locationHandler = (event) => {
  //   const value = event.target.value;
  //   setLocation(value);
  // };

  const searchHandler = (e) => setSearchJob(e.target.value);

  const suggestJobHandler = () => history.push("/jobs/suggest");

  return (
    <div className="campaignsWrapper">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "24px",
          alignItems: "center",
        }}
      >
        <Title
          text="Jobs"
          fontSize={isMobile ? 16 : 32}
          lineHeight={isMobile ? 20 : 40}
          fontWeight={600}
        />
        <CustomButton title={"Suggest a job"} onClick={suggestJobHandler} />
      </div>
      <div style={{ position: "relative", minHeight: "400px" }}>
        {screenWidth > 767 ? (
          <div className="campaignFiltersWrapper">
            {/* <CustomSelect
              label={"Category"}
              style={{ flex: "1 1 calc(33.333% - 20px)" }}
              data={!!locationList ? [{ id: 0, name: "All Categories" }, ...locationList] : []}
              menuWidth={270}
              onChange={locationHandler}
              value={location}
              placeholder={"All Categories"}
            /> */}
            <CustomSelect
              label={"Employment Type"}
              style={{ flex: "1 1 calc(33.333% - 20px)" }}
              data={
                !!employmentTypeList ? [{ id: 0, name: "All Types" }, ...employmentTypeList] : []
              }
              menuWidth={270}
              onChange={employmentTypeHandler}
              value={employmentType}
              placeholder={"All Types"}
            />
            <CustomInput
              label={"Search"}
              EndAdornment={Magnificer}
              placeholder="Search"
              onChange={searchHandler}
              value={searchJob}
              style={{ flex: "1 1 calc(33.333% - 20px)" }}
            />
          </div>
        ) : (
          <div style={{ display: "flex", gap: "12px", width: "100%" }}>
            <CustomInput
              label={"Search"}
              EndAdornment={Magnificer}
              placeholder="Search"
              onChange={searchHandler}
              value={searchJob}
              style={{ flex: 1, maxWidth: "350px" }}
            />
            <div style={{ marginTop: "22px" }} onClick={() => setIsOpen(true)}>
              <FilterIcon />
            </div>
            <SwipeableDrawer
              anchor="right"
              open={isOpen}
              onClose={() => setIsOpen(false)}
              onOpen={() => setIsOpen(true)}
              classes={drawerClasses}
            >
              <div>
                <div
                  style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}
                >
                  <Title text="Filters" />
                  <div onClick={() => setIsOpen(false)}>
                    <Close />
                  </div>
                </div>
                {/* <CustomSelect
                  label={"Category"}
                  data={!!locationList ? [{ id: 0, name: "All Categories" }, ...locationList] : []}
                  menuWidth={270}
                  onChange={locationHandler}
                  value={location}
                  placeholder={"All Categories"}
                /> */}
                <CustomSelect
                  label={"Employment Type"}
                  data={
                    !!employmentTypeList
                      ? [{ id: 0, name: "All Types" }, ...employmentTypeList]
                      : []
                  }
                  menuWidth={270}
                  onChange={employmentTypeHandler}
                  value={employmentType}
                  placeholder={"All Types"}
                />
              </div>
              <CustomButton title={"Close Filters"} onClick={() => setIsOpen(false)} />
            </SwipeableDrawer>
          </div>
        )}
        <JobsList />
      </div>
    </div>
  );
};

const JobsList = () => {
  const { pathname } = useLocation();
  const screenWidth = useSelector((state) => state.common.screenWidth, shallowEqual);
  const jobs = useSelector((state) => state.job.jobs, shallowEqual);
  const isLoading = useSelector((state) => state.job.isLoading, shallowEqual);

  return (
    <>
      {!!jobs?.items.length && !isLoading && (
        <>
          <div className="jobsWrapper">
            {jobs.items.map((job, index) => (
              <JobCard key={index} job={job} />
            ))}
          </div>
          {screenWidth > 767 ? (
            <CustomPagination
              data={jobs}
              tableUrl={pathname}
              pageSize={9}
              scrollToY={0}
              style={{
                borderRadius: "4px",
                marginTop: "20px",
              }}
            />
          ) : (
            <CustomMobilePagination
              data={jobs}
              tableUrl={pathname}
              style={{
                borderRadius: "4px",
                marginTop: "20px",
              }}
            />
          )}
        </>
      )}
      {!jobs?.items.length && !isLoading && (
        <div className="campaignsListWrapper">
          <Title text="No Results" />
        </div>
      )}
      <AnimatedLoading loading={isLoading} width="100%" />
    </>
  );
};

const JobCard = ({ job }) => {
  const history = useHistory();

  const onJobClick = (id) => {
    history.push(`/jobs/view/${id}`);
  };

  return (
    <div className="jobWrapper" onClick={() => onJobClick(job.id)}>
      <div className="jobTitle">
        <Title text={job.title} fontSize={16} fontWeight={600} />
        <Title
          text={`by ${job.contactPerson}`}
          lineHeight={14}
          fontSize={12}
          fontWeight={400}
          color={gray650}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Title text={`$${job.compensation}`} fontWeight={600} fontSize={14} />
        <Title text="/month" fontWeight={400} fontSize={14} />
      </div>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
        {!!job.location && (
          <Title
            className={"jobChips"}
            text={job.location}
            fontWeight={400}
            lineHeight={14}
            fontSize={12}
          />
        )}
        <Title
          className={"jobChips"}
          text={job.employmentType.name}
          fontWeight={400}
          lineHeight={14}
          fontSize={12}
        />
      </div>
      <Title
        text={moment([3, 4].includes(job.status.status) ? job.publishedAt : job.createdAt).format(
          "MM/DD/YYYY h:mm A"
        )}
        fontSize={12}
        lineHeight={14}
        fontWeight={400}
        color={gray650}
      />
    </div>
  );
};

export default Jobs;
